<!-- @author Amol, @date 29-08-2021, @description added assign batch plant company popup component-->
<div class="mainContent">

  <div class="popup-container">
    <div>
      <label i18n="@@spmsUserReg" class="textColour"
        [ngStyle]="{'border-color':backgroundColorButton}">{{btnName}}</label>

      <span class="example-spacer"></span>
    </div>
  </div>

  <!-- <div style="height: 39vh;display: contents;" fxLayout fxLayoutAlign="center center" fxLayoutGap="30px"> -->
  <div class="popup-body">
    <form novalidate style="width: 94%;font-size: 15px;margin-left: 7%;">

      <div class="row" *ngIf="reInitateType === 'cd'">
        <div class="col-lg-5">
          <mat-radio-group layout="row" required [ngModel]="selectedReInitateOrReMigrate"
            (change)="action($event.value)" aria-label="Select an option" style="padding: 5px;margin-left: 56px;"><br>

            <label style="font-weight: 500; font-size: medium; padding-top: 8px;">Select Re-Initiate
              Options:</label><br>
            <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px" value="Extraction">
              Extraction
            </mat-radio-button>
            <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="Transform">
              Transform
            </mat-radio-button><br>
            <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px" value="Load">
              Load
            </mat-radio-button>
            <br>
            <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="Validation">
              Validation
            </mat-radio-button>

          </mat-radio-group>
        </div>
        <div class="col-lg" style="margin-top:4%;margin-bottom: 18%;">
          <label style="font-weight: 500; font-size: medium; padding-top: 8px;">Re-{{this.headertype}} Type:</label><br>
          <mat-radio-group (change)="fullfillAction($event.value)">
            <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px"
              [disabled]="isfullFilledOptDisabled" value="{{this.option1}}">{{this.option1}}
            </mat-radio-button>
            <br>
            <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px"
              [disabled]="isfullFilledOptDisabled" value="{{this.option2}}">{{this.option2}}
            </mat-radio-button>
            <br>
          </mat-radio-group>
        </div>
      </div>
      <div *ngIf="reInitateType === 'ad'" style=" margin-bottom: 18%;">
        <mat-radio-group layout="row" required [ngModel]="selectedReInitateOrReMigrate" (change)="action($event.value)"
          aria-label="Select an option" style="padding: 5px;margin-left: 56px;"><br>

          <label style="font-weight: 500; font-size: medium; padding-top: 8px;">Select Re-Initiate Options:</label><br>
          <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px" value="AttachmentExtraction">
            Attachment Extraction
          </mat-radio-button>
          <br>
          <!--           
            *@Added By Shantanu Ghate
            *@Date 08-03-2026
            *Note this will add the one button in the re-initiate screen to re-initiate the AuditTrailExtraction 
            -->
          <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="AuditTrailExtraction">
            Audit Trail Extraction
          </mat-radio-button>
           <br>
          <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="AttachmentLoadToFTP">
            Attachments Load To FTP
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div *ngIf="reInitateType === 'rm'" style=" margin-bottom: 3%;">

         <mat-radio-group layout="row" required [ngModel]="selectedReInitateOrReMigrate" (change)="action($event.value)"
          aria-label="Select an option" style="padding: 5px;margin-left: 56px;"><br>

          <label style="font-weight: 500; font-size: medium; padding-top: 8px;">Select Re-Migrate Options:</label><br>
          <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px" value="Extraction">Re-migrate
            from extraction
          </mat-radio-button>
      
          <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="Transformation">
            Re-migrate from transformation
          </mat-radio-button>
        </mat-radio-group>

        <div class="row" style="margin-top: 15px;">
          <div class="col-lg-6">
            <mat-form-field appearance="outline" style="width: 100%;">
              <mat-label i18n="@@RCFormulaexpression">Select Mapped Objects</mat-label>
              <mat-select multiple (selectionChange)="onMappedObjectChange($event)" [(ngModel)]="selectedObjects" #mappedObjectsCtrl="ngModel"
                required>
                <mat-option style="background: rgba(0, 0, 0, 0.15)">
                  <span style="display: flex">
                    <div style="width: 45%">Source</div>
                    <div style="width: 10%">-</div>
                    <div style="width: 45%">Target</div>
                  </span>
                </mat-option>
                <mat-option *ngFor="let data of mappingConfigurationData" [value]="data.mappingobjectid">
                  <span style="display: flex">
                    <div style="width: 45%">
                      {{ data.sourceObjectName }}
                    </div>
                    <div style="width: 10%">-</div>
                    <div style="width: 45%">
                      {{ data.targetObjectName }}
                    </div>
                  </span>
                </mat-option>
              </mat-select>
               <mat-error *ngIf="mappedObjectsCtrl.invalid && (mappedObjectsCtrl.touched || mappedObjectsCtrl.dirty)">
      Mapped Object Required.
    </mat-error>

            </mat-form-field>
          </div>

          <div class="col-lg-6">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Select Sets</mat-label>

      <mat-select #setsCtrl="ngModel"
        multiple required [(ngModel)]="selectedSets"(openedChange)="onSetDropdownOpen()">

        <!-- Search box -->
        <mat-option>
          <input
            matInput
            placeholder="Search sets"
            [(ngModel)]="setSearchText"
            (ngModelChange)="filterSets()"
            (click)="$event.stopPropagation()"/>
        </mat-option>

        <!-- Set options -->
        <mat-option
          *ngFor="let set of filteredSetsForDropdown"
          [value]="set.setid">Set {{ set.setid }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="setsCtrl.invalid && (setsCtrl.touched || setsCtrl.dirty)">
      Please select at least one set
    </mat-error>
    </mat-form-field>
  </div>
        </div>

        <div class="agGridOuterDiv"> 
        <div>
            <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);
    border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;
    min-height: 36px; height: 36px; padding: 0 10px;">
    
                        <label i18n="@@spmsUserReg" class="textColour1 gridHeaderText">Mapped Attributes</label>
                        
                      
                  </mat-toolbar>
                </div>
                 <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="mappedAttributesColumnDefs" [animateRows]="true" [pagination]="true" [rowSelection]="'multiple'"
          [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35"
          [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
          [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
          [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()" (selectionChanged)="onSelectionChanged($event)"
          [components]="components" (gridReady)="onMappedAttributesGridReady($event)" [hidden]="!true"
          style="height: 45vh;">
        </ag-grid-angular>
        </div>
   
      </div>
      <!--
        Added for Global data poppup options 
        @modified by sainaveen somaraju
        @date 20/06/2023
      -->
      <div *ngIf="reInitateType === 'gm'" style=" margin-bottom: 18%;">
        <mat-radio-group layout="row" required [(ngModel)]="extractionType" (change)="globalAction($event.value)"
          aria-label="Select an option" style="padding: 5px;margin-left: 56px;"><br>

          <label style="font-weight: 500; font-size: medium; padding-top:30px;">Select Re-Initiate Options:</label><br>
          <mat-radio-button style="font-size: medium; margin-top: 5px;margin-left: 25px" value="Full">
            Full
          </mat-radio-button>
          <br>
          <mat-radio-button style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="Failed">
            Failed
          </mat-radio-button>
          <br>
          <mat-radio-button *ngIf="directdataapiextraction" style="font-size: medium; margin-top: 5px;margin-left: 25px"
            value="UnzipAndExtract">
            UnzipAndExtract
          </mat-radio-button>
          <br>
          <mat-radio-button *ngIf="directdataapiextraction"
            style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="ObjectwiseDatalake">
            ObjectwiseDatalake
          </mat-radio-button>
          <br>
          <mat-radio-button *ngIf="directdataapiextraction"
            style="font-size: medium; margin-left: 25px;margin-top: 5px;" value="SetSplitting">
            SetSplitting
          </mat-radio-button>
        </mat-radio-group>
      </div>

    </form>
  </div>
  <div style="height:5vh;">
    <div class="row" style="position:sticky;left:0;bottom:0;">

      <div class="col-lg text-center">

        <div style="text-align: end;">

          <button _ngcontent-qoy-c414="" (click)="reInitiate()" [title]="btnName"
            class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            style="padding:0.6rem 1.6rem 0.5rem 1.6rem;margin-top: 20px; background-color: rgb(189, 172, 66);">{{btnName}}</button>

          <button _ngcontent-qoy-c414="" (click)="close()" title="Cancel"
            class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.border-color]="backgroundColorButton"
            style="padding:0.5rem 1.5rem 0.5rem;margin-top: 20px;background-color: white !important;color: black;border-width: 1px;border-style: solid;">Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
